import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AdminAuthContext } from '../../context/AdminAuthContext';

function AdminPrivateRoute() {
  const { admin, loading } = useContext(AdminAuthContext);
  if (loading) return <div role="status" className="p-8 text-center">Caricamento…</div>;
  return admin ? <Outlet /> : <Navigate to="/admin/login" />;
}

export default AdminPrivateRoute;
